import compact from 'lodash/compact';
import { ListBooking } from 'types';
import { ItemLinkProps } from '../Components/ItemLinks/ItemLink';
import { viewDetailsLink } from 'lib/gaTracking/bookingListPageEvents';
import { scheduledPaymentUpdateCreditCardLinkSelected, requireUpdateCreditCardLinkSelected } from 'lib/gaTracking/crossPageEvents';
import UpdateCreditCardAlert from './UpdateCreditCardAlert';
import { shouldUpdatePaymentMethod } from '../../BookingListAlert/helpers';

export const generateViewBookingDetailsItemLink = (booking: ListBooking): ItemLinkProps => ({
  label: 'View details',
  url: booking.links.manage,
  onClick: () => viewDetailsLink(booking),
  'data-testid': 'view-booking-details-link',
});

export const generateUpdatePaymentMethodItemLink = (booking: ListBooking): ItemLinkProps | null => {
  const {
    links: { updatePaymentMethod },
    flags: { isFinalising, isChangeInProgress, requiresPaymentMethodUpdate },
  } = booking;
  const isPaymentMethodUpdateRequire = shouldUpdatePaymentMethod(booking);

  if (isFinalising || isChangeInProgress || !isPaymentMethodUpdateRequire) {
    return null;
  }

  // TODO: Remove `requiresPaymentMethodUpdate` ternary check and just track with `scheduledPaymentUpdateCreditCardLinkSelected` once all `up coming booking` have been filly migrated to Adyen payment gateway
  const onClickTracking = requiresPaymentMethodUpdate ? requireUpdateCreditCardLinkSelected : scheduledPaymentUpdateCreditCardLinkSelected;
  const updatePaymentMethodItemLink = {
    label: 'Update credit card',
    url: updatePaymentMethod,
    onClick: onClickTracking,
    'data-testid': 'update-payment-method-link',
    alert: <UpdateCreditCardAlert />,
  };

  return updatePaymentMethodItemLink;
};

export const generateActionItemLinks = (booking: ListBooking): ItemLinkProps[] => {
  const detailsLink = generateViewBookingDetailsItemLink(booking);
  const updatePaymentMethodLink = generateUpdatePaymentMethodItemLink(booking);

  return compact([detailsLink, updatePaymentMethodLink]);
};
